.list {
    composes: safeContainer from "../../styles/composable/layout.module.css";
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    gap: var(--spacer-40);
    justify-content: center;
}

.item {
    width: var(--spacer-152);
    aspect-ratio: 152 / 178;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-width: none;
}
